module.exports = __webpack_public_path__ + "images/1819e2d1497a0e4c6a20068b3a34902b.svg";